import makeStyles from '@mui/styles/makeStyles'
import {
  MyAccountTheme,
  MaLoginOrSignupContainerClasses,
} from '@dxp-module/themes'

const loginOrSignupContainerStyles = makeStyles<
  MyAccountTheme,
  object,
  MaLoginOrSignupContainerClasses
>(
  ({ palette, breakpoints }) => ({
    signup: {
      width: '100%',
      maxWidth: '100%',
      padding: 'auto',
      marginTop: '16px',
      [breakpoints.down('md')]: {
        margin: '16px 0',
        padding: 0,
      },
    },
    login: {
      width: '100%',
      maxWidth: '100%',
      padding: 'auto',
      borderRadius: 0,
      [breakpoints.down('md')]: {
        margin: '16px 0',
        padding: 0,
      },
    },
    container: {
      background: palette.background.alternate,
      width: '100%',
    },
    formContainer: {
      marginTop: 0,
      paddingTop: 0,
      padding: '60px',
      display: 'flex',
      alignItems: 'flex-start',
      [breakpoints.down('md')]: {
        flexDirection: 'column',
        alignItems: 'center',
        padding: '20px',
      },
    },
    formContainerBox: {
      width: '100%',
    },
    imageContainer: {
      width: '100%',
      height: 'auto',
      objectFit: 'cover',
    },
    layoutContainer: {},
  }),
  { name: 'MyAccount_LoginOrSignupContainer' }
)

export default loginOrSignupContainerStyles
